// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-padding {
  padding: 12px;
}

.ion-margin {
  margin: 12px;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--ion-color-secondary);
}

swiper-slide {
  width: 100% !important;
}

.image-wrapper {
  width: 100%;
  position: relative;
}
.image-wrapper ion-img {
  aspect-ratio: 373/257;
  border-radius: 2px;
  overflow: hidden;
  object-fit: contain;
}
.image-wrapper .default-img {
  background-color: #fff;
  padding: 15px;
}
.image-wrapper .info-product-icon {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
}
.image-wrapper .img-info {
  position: absolute;
  bottom: -16px;
  right: 3%;
  font-family: AppFont;
  font-size: 11px;
  color: var(--ion-color-danger);
}
@media (max-width: 992px) {
  .image-wrapper .img-info {
    font-size: 9px;
  }
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  padding-bottom: 120px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.option-group-col {
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
  padding: 0 11px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-btn {
  cursor: pointer;
  position: absolute;
  margin: 0;
  font-size: 40px;
  top: 10px;
  left: 10px;
  z-index: 1;
}

ion-toolbar {
  --ion-toolbar-color: white;
  --ion-toolbar-background: var(--ion-color-primary);
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  height: 36px;
  width: 36px;
  padding: 8px;
}

.menge {
  margin-inline: 16px;
  padding: 16px 0 !important;
  border-top: var(--outline-default);
  border-bottom: var(--outline-default);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge h5 {
  font-family: AppFontSemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.8px;
  text-align: left;
  color: var(--ion-color-primary);
}

.select-size {
  text-align: left;
  padding: 10px 25px !important;
  display: flex;
  flex-direction: column;
}
.select-size ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.info {
  text-align: left;
  padding: 24px 16px !important;
}
.info .title {
  font-family: AppFontBold;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  margin: 0px 0px 7px;
}
.info .desc {
  font-family: AppFontLight;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.01em;
  vertical-align: middle;
}
.info .measurement {
  font-size: 12px;
  line-height: 110%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title > span {
  display: inline-flex;
  align-items: center;
}

.info-icon {
  margin-left: 5px;
  position: relative;
  left: unset;
  right: unset;
  bottom: unset;
  top: unset;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.qty-row {
  margin: 10px 0;
}
.qty-row h2 {
  font-size: 18px;
}

.size-picker {
  margin-top: 20px;
}
.size-picker .chip {
  background: #f5f5f5;
  color: #000;
}
.size-picker .chip.selected {
  background: #000;
  color: #fff;
  font-weight: 500;
}

.step-counter {
  color: var(--ion-color-primary);
}

.first-toolbar {
  padding: 12px;
  backdrop-filter: blur(3px);
  color: black;
}

.option-group-description {
  margin: 20px 16px 0;
  color: #1e1e1c;
  font-family: AppFontBold;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 100%;
  text-align: left;
}

.first-page-header {
  background: red;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
.first-page-header ion-icon {
  zoom: 1.7;
  margin: 0px 5px;
  width: 8%;
}
.first-page-header ion-title {
  text-align: left;
}

.button-price {
  margin-left: 10px;
}

.header-block {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.header-block ion-icon {
  zoom: 0.6;
}

app-tag {
  margin-top: 7px;
  margin-bottom: 16px;
}

ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.footer-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 80px;
  width: 100%;
  z-index: 999;
  background: var(--ion-color-secondary);
  padding: 16px;
}

.footer-button {
  width: 100%;
  height: 54px;
  margin: 0;
  color: var(--ion-color-secondary);
  background: var(--ion-color-primary);
  --background: var(--ion-color-primary);
  --box-shadow: none;
  border: 3px solid var(--color-white);
  padding: 6px;
  border-radius: 6px;
  min-height: auto;
}
.footer-button span {
  font-family: AppFont;
  font-size: 18px;
  line-height: 135%;
  color: var(--ion-color-secondary);
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

app-universal-page-toolbar {
  --title-width: 192px;
}

.error-message {
  font-size: 12px;
  margin: 0;
  margin-left: 16px;
  margin-top: 6px;
  text-align: start;
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAIA;EACC,aAAA;AAHD;;AAMA;EACC,YAAA;AAHD;;AAMA;EACC,aAAA;EACA,kBAAA;AAHD;;AAMA;EACC,sBAAA;EACA,uBAAA;EACA,4CAAA;AAHD;;AAMA;EACC,sBAAA;AAHD;;AAMA;EACC,WAAA;EACA,kBAAA;AAHD;AAIC;EACC,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAKC;EACC,sBAAA;EACA,aAAA;AAHF;AAMC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAJF;AAOC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EAEA,oBAAA;EACA,eAAA;EACA,8BAAA;AANF;AC3CE;ED0CD;IAUE,cAAA;EALD;AACF;;AASA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;EACA,iCAAA;AAND;;AASA;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAND;;AASA;EACC,YAAA;EACA,cAAA;AAND;;AASA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAND;;AASA;EACC,0BAAA;EACA,kDAAA;AAND;AAQC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AANF;AASC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAUA;EACC,mBAlHgB;EAmHhB,0BAAA;EACA,kCAAA;EACA,qCAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AARD;AAUC;EACC,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AARF;;AAWA;EACC,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;AARD;AASC;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAPF;;AAUA;EACC,gBAAA;EACA,6BAAA;AAPD;AASC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,+BAAA;EACA,mBAAA;AARF;AAWC;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;AATF;AAYC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAcA;EACC,oBAAA;EACA,mBAAA;AAXD;;AAcA;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAXD;;AAcA;EACC,cAAA;AAXD;AAaC;EACC,eAAA;AAXF;;AAeA;EACC,gBAAA;AAZD;AAcC;EACC,mBAAA;EACA,WAAA;AAZF;AAcE;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;AAZH;;AAiBA;EACC,+BAAA;AAdD;;AAiBA;EACC,aAAA;EACA,0BAAA;EACA,YAAA;AAdD;;AAiBA;EACC,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAdD;;AAiBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAdD;AAeC;EACC,SAAA;EACA,eAAA;EACA,SAAA;AAbF;AAeC;EACC,gBAAA;AAbF;;AAgBA;EACC,iBAAA;AAbD;;AAeA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AAZD;AAaC;EACC,SAAA;AAXF;;AAcA;EACC,eAAA;EACA,mBAAA;AAXD;;AAaA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAVD;;AAaA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,aAAA;AAVD;;AAaA;EACC,WAAA;EACA,YAAA;EACA,SAAA;EACG,iCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAYC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAVF;;AAcA;EACC,oBAAA;AAXD;;AAcA;EACC,eAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AAXD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n$padding-inline: 16px;\n\n.ion-padding {\n\tpadding: 12px;\n}\n\n.ion-margin {\n\tmargin: 12px;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--ion-color-secondary);\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\n.image-wrapper {\n\twidth: 100%;\n\tposition: relative;\n\tion-img {\n\t\taspect-ratio: 373 / 257;\n\t\tborder-radius: 2px;\n\t\toverflow: hidden;\n\t\tobject-fit: contain;\n\t}\n\n\t.default-img {\n\t\tbackground-color: #fff;\n\t\tpadding: 15px;\n\t}\n\n\t.info-product-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 6px;\n\t}\n\n\t.img-info {\n\t\tposition: absolute;\n\t\tbottom: -16px;\n\t\tright: 3%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tcolor: var(--ion-color-danger);\n\n\t\t@include mobile {\n\t\t\tfont-size: 9px;\n\t\t}\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\tpadding-bottom: 120px;\n\toverflow: auto;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.option-group-col {\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tmargin-top: 10px;\n\tpadding: 0 ($padding-inline - 5px);\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\tmargin: 0;\n\tfont-size: 40px;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 1;\n}\n\nion-toolbar {\n\t--ion-toolbar-color: white;\n\t--ion-toolbar-background: var(--ion-color-primary);\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tpadding: 8px;\n\t}\n}\n.menge {\n\tmargin-inline: $padding-inline;\n\tpadding: 16px 0 !important;\n\tborder-top: var(--outline-default);\n\tborder-bottom: var(--outline-default);\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\th5 {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tline-height: 21.8px;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.select-size {\n\ttext-align: left;\n\tpadding: 10px 25px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tion-item {\n\t\tborder-radius: 5px;\n\t\tmargin-top: 10px;\n\t\tborder: 0.5px solid #e2dcd5;\n\t}\n}\n.info {\n\ttext-align: left;\n\tpadding: 24px $padding-inline !important;\n\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 26px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--ion-color-primary);\n\t\tmargin: 0px 0px 7px;\n\t}\n\n\t.desc {\n\t\tfont-family: AppFontLight;\n\t\tfont-size: 14px;\n\t\tline-height: 150%;\n\t\tletter-spacing: -0.01em;\n\t\tvertical-align: middle;\n\t}\n\n\t.measurement {\n\t\tfont-size: 12px;\n\t\tline-height: 110%;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.title > span {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.info-icon {\n\tmargin-left: 5px;\n\tposition: relative;\n\tleft: unset;\n\tright: unset;\n\tbottom: unset;\n\ttop: unset;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n}\n\n.qty-row {\n\tmargin: 10px 0;\n\n\th2 {\n\t\tfont-size: 18px;\n\t}\n}\n\n.size-picker {\n\tmargin-top: 20px;\n\n\t.chip {\n\t\tbackground: #f5f5f5;\n\t\tcolor: #000;\n\n\t\t&.selected {\n\t\t\tbackground: #000;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n\n.step-counter {\n\tcolor: var(--ion-color-primary);\n}\n\n.first-toolbar {\n\tpadding: 12px;\n\tbackdrop-filter: blur(3px);\n\tcolor: black;\n}\n\n.option-group-description {\n\tmargin: 20px $padding-inline 0;\n\tcolor: #1e1e1c;\n\tfont-family: AppFontBold;\n\tfont-size: 20px;\n\ttext-transform: uppercase;\n\tline-height: 100%;\n\ttext-align: left;\n}\n\n.first-page-header {\n\tbackground: red;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: white;\n\twidth: 100%;\n\tion-icon {\n\t\tzoom: 1.7;\n\t\tmargin: 0px 5px;\n\t\twidth: 8%;\n\t}\n\tion-title {\n\t\ttext-align: left;\n\t}\n}\n.button-price {\n\tmargin-left: 10px;\n}\n.header-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\tion-icon {\n\t\tzoom: 0.6;\n\t}\n}\napp-tag {\n\tmargin-top: 7px;\n\tmargin-bottom: 16px;\n}\nion-item {\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.footer-container {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 80px;\n\twidth: 100%;\n\tz-index: 999;\n\tbackground: var(--ion-color-secondary);\n\tpadding: 16px;\n}\n\n.footer-button {\n\twidth: 100%;\n\theight: 54px;\n\tmargin: 0;\n    color: var(--ion-color-secondary);\n    background: var(--ion-color-primary);\n    --background: var(--ion-color-primary);\n    --box-shadow: none;\n    border: 3px solid var(--color-white);\n    padding: 6px;\n    border-radius: 6px;\n    min-height: auto;\n\n\tspan {\n\t\tfont-family: AppFont;\n\t\tfont-size: 18px;\n\t\tline-height: 135%;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-weight: 400;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\n\napp-universal-page-toolbar {\n\t--title-width: 192px;\n}\n\n.error-message {\n\tfont-size: 12px;\n\tmargin: 0;\n\tmargin-left: 16px;\n\tmargin-top: 6px;\n\ttext-align: start;\n\tcolor: var(--ion-color-danger);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
